import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TrophyIcon } from '@heroicons/react/24/outline';
import { useUser } from '../userContext';

function LiveCampaignStatus() {
  const { campaigns } = useUser();
  const navigate = useNavigate();

  // Calculate live campaigns from context (free - no DB query)
  const liveCampaigns = campaigns ? campaigns.filter(campaign => campaign.status === 'live') : [];
  const liveCampaignCount = liveCampaigns.length;

  const handleClick = () => {
    navigate('/studio/campaigns');
  };

  return (
    <div className="mt-auto pt-4 border-t border-yellow-400/20">
      <button
        onClick={handleClick}
        className="w-full px-3 py-2 rounded-lg bg-yellow-400/10 border border-yellow-400/30 hover:bg-yellow-400/20 transition-all duration-200 cursor-pointer"
      >
        <div className="flex items-center">
          <TrophyIcon className="h-4 w-4 text-yellow-400 shrink-0" />
          <div className="ml-2 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
            <div className="text-xs font-bold text-yellow-400">CAMPAIGNS LIVE</div>
            <div className="text-xs text-gray-300">
              {liveCampaignCount} Active Campaign{liveCampaignCount !== 1 ? 's' : ''}
            </div>
          </div>
        </div>
      </button>
    </div>
  );
}

export default LiveCampaignStatus; 